export * from './FolderSharedIcon';
export * from './FolderSharedIcon16Light';
export * from './FolderSharedIcon16Regular';
export * from './FolderSharedIcon16Solid';
export * from './FolderSharedIcon20Light';
export * from './FolderSharedIcon20Regular';
export * from './FolderSharedIcon20Solid';
export * from './FolderSharedIcon24Regular';
export * from './FolderSharedIcon24Solid';
export * from './FolderSharedIcon32Regular';
export * from './FolderSharedIcon64Regular';
